import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36f87114")

_pushScopeId("data-v-36f87114")
const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "formDiv" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", null, "Kurzname:", -1)
const _hoisted_5 = { class: "formDiv" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "URL*:", -1)
const _hoisted_7 = {
  key: 0,
  id: "alert"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "formDiv" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_GenericDialog = _resolveComponent("GenericDialog")

  return (_openBlock(), _createBlock(_component_GenericDialog, {
    header_text: _ctx.header_text,
    max_width: "450px",
    onClose: _ctx.onCancel
  }, {
    default: _withId(() => [
      (_ctx.waiting)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingSpinner)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.body_text) + " ", 1),
            _createVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
            }, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
                  name: "name",
                  placeholder: "Name der Wissensbasis"
                }, null, 512), [
                  [_vModelText, _ctx.name]
                ])
              ]),
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.url = $event)),
                  name: "url",
                  placeholder: "URL der Wissensbasis"
                }, null, 512), [
                  [_vModelText, _ctx.url]
                ])
              ]),
              (_ctx.alertText)
                ? (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(_ctx.alertText), 1))
                : _createCommentVNode("", true),
              _hoisted_8
            ], 32)
          ]))
    ]),
    footer: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.footer_text) + " ", 1),
      _createVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmit())),
        id: "submitBtn"
      }, " Bestätigen ")
    ]),
    _: 1
  }, 8, ["header_text", "onClose"]))
})